export default [{
	titulo: 'Empresas',
	icone: 'menu-icon fa fa-caret-right',
	url: '/admin/empresas',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]